import { render, staticRenderFns } from "./QuestionCardForConverting.vue?vue&type=template&id=3e6870dc&"
import script from "./QuestionCardForConverting.vue?vue&type=script&lang=ts&"
export * from "./QuestionCardForConverting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports